import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icon-eye.svg'
import _imports_1 from '@/assets/images/icon-home.svg'
import _imports_2 from '@/assets/images/icon-store.svg'


const _withScopeId = n => (_pushScopeId("data-v-9decc050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "absolute top-4 right-4 flex flex-row w-full items-center justify-end gap-4" }
const _hoisted_2 = { class: "flex flex-col w-1/4" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "flex flex-row w-full h-full gap-2" }
const _hoisted_5 = { class: "flex flex-col gap-4 w-full p-4" }
const _hoisted_6 = { class: "flex flex-col gap-1 w-full h-full" }
const _hoisted_7 = { class: "flex flex-row items-center w-full" }
const _hoisted_8 = { class: "flex flex-col lg:flex-row font-bold w-full gap-2 items-start lg:items-center justify-start" }
const _hoisted_9 = { class: "flex flex-row gap-4 items-center" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-row items-center justify-start gap-2"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "lg:w-full h-4"
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 0,
  class: "flex flex-row items-center justify-start gap-2"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "lg:w-full h-4"
}, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "lg:block lg:visible font-bold text-[16px]" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-col text-start gap-1"
}
const _hoisted_18 = { class: "flex flex-row justify-start lg:justify-between" }
const _hoisted_19 = {
  key: 0,
  class: "flex lg:flex-row flex-col gap-1 lg:w-[200px] bg-[#F6FFAD] rounded-sm items-start justify-start lg:items-center lg:justify-center px-3 py-1"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Valor de compra:", -1))
const _hoisted_21 = {
  key: 1,
  class: "flex lg:flex-row flex-col gap-1 lg:w-[200px] bg-[#CCED57] rounded-sm items-start justify-start lg:items-center lg:justify-center px-3 py-1"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Renta:", -1))
const _hoisted_23 = {
  key: 2,
  class: "flex lg:flex-row flex-col gap-1 lg:w-[200px] bg-[#CCED57] rounded-sm items-start justify-start lg:items-center lg:justify-center px-3 py-1"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Renta:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { PropType, Ref, ref } from "vue";
import { Investment, InvestimentEnum } from "@/services/invest/types";
import { InvestmentService } from "@/services/invest/investmentService";
import PreviewInvestimentModal from "@/components/organisms/PreviewInvestimentModal.vue";
import {
  toBadgeFormat,
  upercaseToTitle,
  toBadgeFormatUf,
} from "@/services/utils";
//import EditInvestmentModal from "@/components/organisms/EditInvestmentModal.vue";
import { getEnvConfig } from "@/configs/UrlConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'InvestCard',
  props: {
  reloadInfo: {
    type: Function,
    required: false,
  },
  invest: {
    type: Object as PropType<Investment>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const keyIndexInvestModal = ref(0);
const showModal = ref<boolean>(false);
const showModalPreview = ref<boolean>(false);
const lastRecordDaste: Ref<Date | null> = ref(null);
const showModalEdit = ref<boolean>(false);
const investmentService = new InvestmentService();

async function getInvestiment() {
  let result = null;
  try {
    if (props.invest && props.invest.id) {
      result = await investmentService.getLastRecordDate(props.invest.id);
      lastRecordDaste.value = result.data;
    }
  } catch (error) {
    console.log(error);
  }
  return result;
}

getInvestiment();

function getUrl(relativeUrl: string) {
  relativeUrl;
  let url = new URL(relativeUrl.substring(1), "http://localhost:8000");
  return url;
}
function handleAddRecord(e: Event) {
  e.stopPropagation();
  showModal.value = true;
  showModalEdit.value = false;
}
function handlePreview(e: Event) {
  e.stopPropagation();
  showModalPreview.value = true;
  showModalEdit.value = false;
}
function handleEdit() {
  showModalEdit.value = true;
  showModal.value = false;
  showModalPreview.value = false;
}
function reload() {
  getInvestiment();
  keyIndexInvestModal.value++;
}
function getNumberOfDays(start: Date) {
  const date1 = new Date(start);
  const date2 = new Date(Date.now());

  // One day in milliseconds
  const oneDay = 1000 * 60 * 60 * 24;

  // Calculating the time difference between two dates
  const diffInTime = date2.getTime() - date1.getTime();

  // Calculating the no. of days between two dates
  const diffInDays = Math.round(diffInTime / oneDay);

  return diffInDays;
}

function formatSeparateLine(description: string) {
  return description.split("\n");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "relative flex flex-row cursor-pointer w-full h-fit bg-white card-invest rounded-lg overflow-hidden",
      onClick: handleEdit
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("img", {
          src: _imports_0,
          class: "h-4",
          onClick: _cache[0] || (_cache[0] = (e) => handlePreview(e))
        })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (__props.invest?.thumbnail != null)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _unref(getEnvConfig)().apiURL + __props.invest.thumbnail.slice(1),
              alt: "rentas-dhelos-invest",
              class: "bg-cover h-full w-full object-cover"
            }, null, 8, _hoisted_3))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_unref(InvestimentEnum)[0] == __props.invest?.investmentType)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                    : _createCommentVNode("", true)
                ]),
                (_unref(InvestimentEnum)[1] == __props.invest?.investmentType)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_16, _toDisplayString(__props.invest?.title), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex flex-row items-center gap-2", 
                  __props.invest?.investmentStatus == 'ARRENDADO'
                    ? 'text-red-700'
                    : __props.invest?.investmentStatus == 'DISPONIBLE'
                    ? 'text-green-700'
                    : ''
                ])
                }, _toDisplayString(__props.invest.investmentStatus
                    ? _unref(upercaseToTitle)(__props.invest?.investmentStatus)
                    : ""), 3)
              ])
            ]),
            (__props.invest?.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formatSeparateLine(__props.invest?.description), (desc) => {
                    return (_openBlock(), _createElementBlock("p", { key: desc }, _toDisplayString(desc), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_18, [
              (__props.invest.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("p", null, "UF " + _toDisplayString(__props.invest.value ? _unref(toBadgeFormat)(__props.invest.value) : ""), 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.invest.monthlyProfitabilityClp)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("p", null, " $" + _toDisplayString(__props.invest.monthlyProfitabilityClp
                    ? _unref(toBadgeFormat)(__props.invest.monthlyProfitabilityClp)
                    : "") + " mes ", 1)
                  ]))
                : _createCommentVNode("", true),
              (__props.invest.monthlyProfitabilityUf)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("p", null, " UF " + _toDisplayString(__props.invest.monthlyProfitabilityUf
                    ? _unref(toBadgeFormatUf)(__props.invest.monthlyProfitabilityUf)
                    : "") + " mes ", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _hoisted_25
          ])
        ])
      ])
    ]),
    (__props.invest)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          (_openBlock(), _createBlock(PreviewInvestimentModal, {
            visible: showModalPreview.value,
            "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((showModalPreview).value = $event)),
            invest: __props.invest,
            type: 0,
            key: keyIndexInvestModal.value
          }, null, 8, ["visible", "invest"]))
        ]))
      : _createCommentVNode("", true),
    _hoisted_27
  ], 64))
}
}

})